import notificationStreamModule from "../notificationStreamModule";

function layoutLibraryService($log, languageResource) {
    "ngInject";

    var lang = languageResource;
    return {
        links: {
            profileLinkName: "goToProfilePage",
            profileLink: "/users/{id}/profile",
            friendRequestLinkName: "viewAllFriendRequests",
            friendRequestTabName: "Friends",
            friendRequestLink: "/users/friends#!/friend-requests",
            settingLinkName: "goToSettingPage",
            settingTabName: "Settings",
            settingLink: "/my/account#!/notifications",
            friendsTabName: "Friends",
            friendsLink: "/users/friends",
            inboxTabName: "Messages",
            inboxLink: "/my/messages/#!/inbox",
            inboxMessageDetailQuery: "?conversationId="
        },

        stringTemplates: {
            boldLink: "<a class='font-caption-header'>{username}</a>",
            userLink: "<a class='text-name small font-caption-header' type='goToProfilePage' user_id='{userid}' href='{profilelink}'>{username}</a>"
        },

        newFriendRequests: function (numberOfRequests) {
            return lang.get("Message.YouHaveNewFriendRequests", { numberOfRequests: numberOfRequests });
        },

        newFriends: function (numberOfFriends) {
            return lang.get("Message.YouHaveNewFriends", { numberOfFriends: numberOfFriends });
        },

        friendRequestAcceptedSingle: function (userOne) {
            return lang.get("Message.FriendRequestAcceptedSingle", { userOne: userOne });
        },

        friendRequestAcceptedDouble: function (userOne, userTwo) {
            return lang.get("Message.FriendRequestAcceptedDouble", { userOne: userOne, userTwo: userTwo });
        },

        friendRequestAcceptedMultiple: function (userOne, userTwo, userMultipleCount) {
            return lang.get("Message.FriendRequestAcceptedMultiple", { userOne: userOne, userTwo: userTwo, userMultipleCount: userMultipleCount });
        },

        friendRequestSentSingle: function (userOne) {
            return lang.get("Message.FriendRequestSentSingle", { userOne: userOne });
        },

        friendRequestSentDouble: function (userOne, userTwo) {
            return lang.get("Message.FriendRequestSentDouble", { userOne: userOne, userTwo: userTwo });
        },

        friendRequestSentMultiple: function (userOne, userTwo, userMultipleCount) {
            return lang.get("Message.FriendRequestSentMultiple", { userOne: userOne, userTwo: userTwo, userMultipleCount: userMultipleCount });
        },

        confirmAcceptedSingle: function (userOne) {
            return lang.get("Message.ConfirmAcceptedSingle", { userOne: userOne });
        },

        confirmAcceptedDouble: function (userOne, userTwo) {
            return lang.get("Message.ConfirmAcceptedDouble", { userOne: userOne, userTwo: userTwo });
        },

        confirmAcceptedMultiple: function (userOne, userTwo, userMultipleCount) {
            return lang.get("Message.ConfirmAcceptedMultiple", { userOne: userOne, userTwo: userTwo, userMultipleCount: userMultipleCount });
        },

        confirmSentSingle: function (userOne) {
            return lang.get("Message.ConfirmSentSingle", { userOne: userOne });
        },

        confirmSentDouble: function (userOne, userTwo) {
            return lang.get("Message.ConfirmSentDouble", { userOne: userOne, userTwo: userTwo });
        },

        confirmSentMultiple: function (userOne, userTwo, userMultipleCount) {
            return lang.get("Message.ConfirmSentMultiple", { userOne: userOne, userTwo: userTwo, userMultipleCount: userMultipleCount });
        },

        textTemplate: {
            newNotification: function (numberOfNotifications) {
                return lang.get("Message.NumberofNewNotifications", { notificationCount: numberOfNotifications });
            },
            noNetworkConnectionText: function () {
                return lang.get("Label.NoNetworkConnectionText");
            }
        },

        tooManyFriendsSelf: function () {
            return lang.get("Message.TooManyFriendsSelf");
        },

        tooManyFriendsOther: function () {
            return lang.get("Message.TooManyFriendsOther");
        },

        friendRequestActionType: {
            acceptIgnoreBtns: "AcceptIgnoreBtns",
            chatBtn: "chatBtn",
            viewAllBtn: "ViewAllBtn"
        },

        directiveTemplatesName: {
            notificationIndicatorTemplate: "notification-indicator",
            notificationStreamIndicatorTemplate: "notification-stream-indicator",
            notificationContentTemplate: "notification-content",
            friendRequestReceivedTemplate: "friend-request-received",
            friendRequestAcceptedTemplate: "friend-request-accepted",
            friendRequestTemplate: "friend-request",
            privateMessageTemplate: "private-message",
            developerMetricsAvailableTemplate: "developer-metrics-available",
            testTemplate: "test",
            notificationStreamBaseTemplate: "notification-stream-base",
            notificationStreamIconTemplate: "notification-stream-icon",
            notificationContentViewTemplate: "notification-content-view-template",
            gameUpdateTemplate: "game-update-template",
            gameUpdateActionPopoverTemplate: "game-update-action-popover-template",
            notificationStreamBaseViewTemplate: "notification-stream-base-view",
            notificationStreamContainerTemplate: "notification-stream-container"
        },

        notificationSourceType: {
            test: "Test",
            friendRequestReceived: "FriendRequestReceived",
            friendRequestAccepted: "FriendRequestAccepted",
            privateMessageReceived: "PrivateMessageReceived",
            developerMetricsAvailable: "DeveloperMetricsAvailable",
            gameUpdate: "GameUpdate"
        },

        gameUpdates: {
            formatDisplayTextDouble: function (game1, game2) {
                return lang.get(
                    "Message.AggregatedGameUpdateDouble",
                    {
                        gameOne: "<span class='font-caption-header'>" + game1 + "</span>",
                        gameTwo: "<span class='font-caption-header'>" + game2 + "</span>"
                    }
                );
            },

            formatDisplayTextMultiple: function (game1, game2, otherCount) {
                return lang.get(
                    "Message.AggregatedGameUpdateMultiple",
                    {
                        gameOne: "<span class='font-caption-header'>" + game1 + "</span>",
                        gameTwo: "<span class='font-caption-header'>" + game2 + "</span>",
                        otherCount: otherCount
                    }
                );
            }
        }
    }
}

notificationStreamModule.factory("layoutLibraryService", layoutLibraryService);

export default layoutLibraryService;